<template>
  <h1>Hello Harish Raghav</h1>
  <h2>Nice to meet you</h2>
  <h3>Welcome to Vue 3</h3>
</template>

<script>
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
